import { forwardRef } from 'react';

import clsx from 'clsx';

import { header } from './Modal.css';
import { ModalHeaderProps } from './types';

export const ModalHeader = forwardRef<HTMLDivElement, ModalHeaderProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={clsx(header, className)} {...props}>
        {children}
      </div>
    );
  },
);

ModalHeader.displayName = 'ModalHeader';
